import React from 'react';
import {
  SkeletonDisplayText,
  SkeletonBodyText,
  TextContainer,
} from '@shopify/polaris';

import styles from './ReviewListing.scss';

export function SkeletonReviewListing() {
  return (
    <article className={styles.ReviewListing}>
      <TextContainer>
        <SkeletonDisplayText size="large" />
        <SkeletonBodyText lines={5} />
      </TextContainer>
    </article>
  );
}
